module.exports = __webpack_public_path__ + "fafa9f7fae9b40d9bf5b71965a1998e6.svg";